import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';

import { AlertService, ApiService } from '../../_services';

@Component({templateUrl: 'reset-password.component.html'})
export class ResetPasswordComponent implements OnInit {
    resetForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    resetPWModel: any ={};
    selectedType: number;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private apiService: ApiService,
        private alertService: AlertService) {
            this.resetForm = this.formBuilder.group({
                memberId: [''],
                email: ['']
            });
        }

    ngOnInit() {
        
    }

    requestResetPassword(){
        this.apiService.requestResetPassword(this.resetPWModel).subscribe(r=>{
            this.alertService.success(r.message);
        }, err=>{
            this.alertService.error(err.error);
            console.log(err);
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/login/reset-password/reset-password.component.ts